import React from "react";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";

export const GoToBack = ({ children }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center", // vertically center icon and text
        gap: "5px",          // small gap between icon and text
        marginBottom: "0px",
        marginTop: "70px",
        paddingBottom: "0px",
        paddingTop: "0px",
        paddingLeft: "100px",
      }}
      className="responsive"
    >
      <KeyboardBackspaceIcon
        onClick={() => window.history.back()}
        style={{
          height: "30px", // normal icon size
          width: "40px",
          padding: 0,     // remove all padding
          margin: 0,      // remove margin
          color: "black",
         // backgroundColor:"green"

        }}
        className="GoToBackIcon"
      />
      <h4
        style={{
          margin: 0,
        }}
      >
        <b>{children}</b>
      </h4>
    </div>
  );
};
